/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Room from './Room'
import Sensor from './Sensor'

/**
 * The InlineResponse20037 model module.
 * @module model/InlineResponse20037
 * @version 1.0.0
 */
export default class InlineResponse20037 {
  /**
   * Constructs a new <code>InlineResponse20037</code>.
   * @alias module:model/InlineResponse20037
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20037</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20037} obj Optional instance to populate.
   * @return {module:model/InlineResponse20037} The populated <code>InlineResponse20037</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20037()

      if (data.hasOwnProperty('room')) {
        obj['room'] = Room.constructFromObject(data['room'])
      }
      if (data.hasOwnProperty('sensors')) {
        obj['sensors'] = ApiClient.convertToType(data['sensors'], [Sensor])
      }
    }
    return obj
  }

  /**
   * @member {module:model/Room} room
   */
  room = undefined
  /**
   * @member {Array.<module:model/Sensor>} sensors
   */
  sensors = undefined
}
